export default __webpack_public_path__ + "static/media/exisitng1.d07bafcf.png";